import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import AddNotAcceptedComment from '../../../widgets/notAcceptedComment/notAcceptedComment'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getNotAccepted } from '../../../redux/actions/notAccepted'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'

export default function ProposalRevise() {
  const [isEditAll, setIsEditAll] = useState(false)
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async (projectVersionId, projectReviewerId) => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getNotAccepted(projectId)
      setSchema(_schema)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal>
          <ContentHeader header={schema.model.header} subHeader={schema.model.subHeader} />

          <AddNotAcceptedComment
            showCommandButton={true}
            isEditAll={isEditAll}
            schema={schema.model}
          />
          <br />
        </SidebarProposal>
      )}
    </>
  )
}

// const formSchema = {
//   header: 'ไม่รับพิจารณา',
//   subHeader: '',
//   addComment: {
//     header: 'ส่งความคิดเห็น/เหตุผล ไม่รับพิจารณา (กล่นกรองทางวิชาการ)',
//     buttonText: 'บันทึกความคิดเห็น/เหตุผล',
//     inputAddComment: {
//       name: 'comment',
//       label: 'ความคิดเห็น/เหตุผล',
//       value: '',
//       validators: [
//         {
//           type: 'REQUIRED',
//           errorMessage: 'กรุณาระบุความคิดเห็น/เหตุผล',
//         },
//       ],
//     },
//   },
// }
